import Navbar from './Navbar';
import Seo from './Seo';
import useInView from './useInView';
import soberPartyPage from './images/sober_party.png';
import memoGamePage from './images/memo_game.png';
import wordleGamePage from './images/wordle_game.png';

const SingleProjectComponent = (props) => {
    const [ref, inView] = useInView();
    return (
        <div
            ref={ref}
            className={`reveal flex flex-col lg:flex-row justify-evenly items-center ${
                inView ? 'is-visible' : ''
            }`}
            style={{ transitionDelay: `${props.index * 120}ms` }}>
            <div className='w-5/6 lg:w-2/6  relative project-image-container'>
                <img
                    src={props.image}
                    alt={props.header}
                    className='project-image'></img>
                <div className='link-above-image w-full'>
                    <a
                        href={props.link}
                        target='_blank'
                        rel='noreferrer'
                        className='text w-full px-2 md:text-3xl md:py-4 md:px-8'>
                        Visit the website
                    </a>
                </div>
            </div>
            <div className='w-5/6 lg:w-2/6'>
                <h4 className='text-3xl py-5 font-semibold'>{props.header}</h4>
                <p className='text-left text-2xl'> {props.text}</p>
                <div className='flex gap-3 mt-1 mb-7'>
                    {/* <p className='colored-text text-2xl font-bold'>Stack:</p> */}
                    <ul className='flex gap-3 lg:gap-5 text-xl lg:text-2xl'>
                        {props.stack.map((technology, index) => (
                            <li key={index} className='colored-text'>
                                {technology}
                            </li>
                        ))}
                    </ul>
                </div>
                <button className='hbtn text-xl lg:text-2xl font-semibold'>
                    <a href={props.link} target='_blank' rel='noreferrer'>
                        Visit the website
                    </a>
                </button>
            </div>
        </div>
    );
};
const Projects = () => {
    const memoText = `I built this just for fun and to learn more about constellations.
    While creating the game I focused on animations and practising TDD.`;

    const soberPartyText = `A project I made for myself after struggling to find a good site with mocktail and non-alcoholic drink recipes.
    Along the way I learned how to use Redux.`;
    const wordleText = `I love playing Wordle, so I built my own version in my favourite languages.
    It's a small project with smooth animations and an accessible modal built with Headless UI.`;

    return (
        <div>
            <Seo
                title='Projects — Elmira Saifullina'
                description='Side projects by Elmira Saifullina: a constellations memo game, a Wordle clone, and a mocktail recipe app, built with React, Next.js and TypeScript.'
                path='/projects'
            />
            <Navbar />
            <h1 className='text-4xl pt-10 pb-2 page-header'>Projects</h1>
            <h2 className='text-2xl pb-10 w-8/12 mx-auto'>
                {`A few things I've built in my free time to explore new tools and ideas.
                These are playgrounds for the code and the craft more than polished design pieces :)`}
            </h2>

            <div className='flex flex-col gap-10 text-xl mb-5'>
                <SingleProjectComponent
                    index={0}
                    image={memoGamePage}
                    header='Constellations memo game'
                    link='https://spacememo.esaifullina.com/'
                    text={memoText}
                    stack={['Next.js', 'Typescript']}
                />
                <SingleProjectComponent
                    index={1}
                    image={wordleGamePage}
                    header='Wordle game'
                    link='https://wordle.esaifullina.com/'
                    text={wordleText}
                    stack={['React.js']}
                />
                <SingleProjectComponent
                    index={2}
                    image={soberPartyPage}
                    header='Sober Party'
                    link='https://soberparty.esaifullina.com/'
                    text={soberPartyText}
                    stack={['React', 'Node.js', 'Tailwind CSS', 'MongoDB']}
                />
            </div>
        </div>
    );
};
export default Projects;
